import { JupiterTheme } from '@jupiterone/jupiter-web-toolkit';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import { createStyles, makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import React, { ReactNode, useMemo } from 'react';
import MeshIcon from '../icons/mesh';
import TreeIcon from '../icons/node-tree';
import { GraphViewType } from '../types';

const useStyles = makeStyles((theme: JupiterTheme) =>
  createStyles({
    rotated: { transform: 'rotate(-90deg)' },
  })
);

interface Props {
  onUpdateGraphType: (newType: GraphViewType) => void;
  graphType: GraphViewType;
  inheritedClasses: { icon: string; button: string };
}

interface GraphTypeItem {
  Icon: ReactNode;
  type: GraphViewType;
  label: string;
}

const GraphTypeButton = ({
  inheritedClasses,
  graphType,
  onUpdateGraphType,
}: Props) => {
  const classes = useStyles();
  const graphTypes: GraphTypeItem[] = [
    {
      Icon: <MeshIcon className={inheritedClasses.icon} />,
      type: GraphViewType.mesh,
      label: 'Network',
    },
    {
      Icon: (
        <TreeIcon className={clsx(inheritedClasses.icon, classes.rotated)} />
      ),
      type: GraphViewType.tree,
      label: 'Horizontal Tree',
    },
    {
      Icon: <TreeIcon className={inheritedClasses.icon} />,
      type: GraphViewType.tree_horizontal,
      label: 'Vertical Tree',
    },
  ];

  const currentIndex = graphTypes.findIndex((t) => t.type === graphType) || 0;
  const nextType: GraphTypeItem = useMemo(() => {
    if (currentIndex === graphTypes.length - 1) {
      return graphTypes[0];
    }
    return graphTypes[currentIndex + 1];
  }, [graphType]);

  return (
    <Tooltip title={'Toggle Layout'} placement="top" enterDelay={500}>
      <Button
        aria-label={nextType.label}
        className={inheritedClasses.button}
        variant="text"
        size="small"
        onClick={() => onUpdateGraphType(nextType.type)}
      >
        {graphTypes[currentIndex].Icon}
      </Button>
    </Tooltip>
  );
};

export default GraphTypeButton;
